const Separator = ({ }) => {
    return (
        <div class="separator separator-dotted mt-3 mb-5"></div>
    );
};

export default Separator;